export default {
  marshal: (data) => {
    return {
      fields: data.fields || null,
      formDefId: data.formDefId || null,
      formType: data.formType || null,
      language: data.language || null,
      status: data.status || null,
      token: data.token || null,
      tenantId: data.tenantId || null,
      accreditationRequestId: data.accreditationRequestId || null,
      credentialProfileId: data.credentialProfileId || null,
      projectId: data.projectId || null,
      eventId: data.eventId || null,
      continueAsGuest: data.continueAsGuest ?? true,
      loginEnabled: data.loginEnabled ?? true,
      createAccountEnabled: data.createAccountEnabled ?? true,
      magicFieldsData: data.magicFieldsData || null

    };
  },
};
